import { useState } from "react";
import { TabPanel } from "@mui/lab";
import { Box, Button, Stack, Typography as T } from "@mui/material";
import DatasetPageLayout from "datasets/components/DatasetPageLayout";
import EmptyStateText from "datasets/components/EmptyStateText";
import usePermissions from "datasets/hooks/usePermissions";
import AddReportModal from "datasets/pages/dashboards/components/AddReportModal";
import DatasetReportList from "datasets/pages/dashboards/components/DatasetReportList";
import useDatasetDashboards from "datasets/pages/dashboards/hooks/useDatasetDashboards";
import { PlusIcon } from "~/assets/icons";
import useDatasetPermission from "~/pages/datasets/hooks/useDatasetPermission";

const EmptyReports = ({ onClick }: { onClick: () => void }) => {
  const canCreate = useDatasetPermission("create:catalog-report");

  return (
    <Stack alignItems="center" gap={3} mt={12}>
      {canCreate ? (
        <>
          <EmptyStateText>
            This dataset has no dashboards.
            <br /> Add a dashboard below to get started.
          </EmptyStateText>
          <Button startIcon={<PlusIcon />} color="primary" variant="contained" onClick={onClick}>
            Add Dashboard
          </Button>
        </>
      ) : (
        <EmptyStateText>This dataset has no dashboards.</EmptyStateText>
      )}
    </Stack>
  );
};

const DatasetReports = () => {
  const { data: reports, isLoading: loadingReports } = useDatasetDashboards();
  const canCreate = useDatasetPermission("create:catalog-report");
  const [open, setOpen] = useState(false);
  const showEmpty = !loadingReports && reports?.length === 0;

  return (
    <TabPanel value="reports" sx={{ p: 0 }}>
      <DatasetPageLayout bgcolor="common.dimmedPageBackground">
        {showEmpty ? (
          <EmptyReports onClick={() => setOpen(true)} />
        ) : (
          <Stack gap={2} alignItems="flex-start">
            <Box
              display="flex"
              gap={1}
              width="100%"
              minHeight={36}
              alignItems="center"
              justifyContent="space-between"
            >
              <T component="h1" fontSize={18} fontWeight={600}>
                Dashboards
              </T>
              {canCreate && (
                <Button startIcon={<PlusIcon />} variant="contained" onClick={() => setOpen(true)}>
                  Add Dashboard
                </Button>
              )}
            </Box>
            <DatasetReportList />
          </Stack>
        )}
        <AddReportModal open={open} onClose={() => setOpen(false)} />
      </DatasetPageLayout>
    </TabPanel>
  );
};

export default DatasetReports;
